import React from 'react'

import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import DaftarSekolah from 'app/KinerjaPSPage/pages/sekolah/DaftarSekolah'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import PageGuardPengawas from 'app/KinerjaPSPage/components/PageGuardPengawas'
import { PENGELOLAAN_KINERJA_NOT_FOUND_PATH } from 'app/KinerjaShared/constants/path'

import type { PageProps } from 'app/KinerjaShared/components/KinerjaLayout'
import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const isKinerjaPsEnabled = toggle['kinerja-ps-enabled'] || false
    const isKinerjaPsPenilaianKsEnabled =
      toggle['kinerja-ps-penilaian-ks-enabled'] || false
    const isEnabled = isKinerjaPsEnabled && isKinerjaPsPenilaianKsEnabled

    if (!isEnabled) {
      return {
        redirect: {
          destination: PENGELOLAAN_KINERJA_NOT_FOUND_PATH,
          permanent: false,
        },
      }
    }
  },
})

const Page = (props: PageProps) => (
  <PageGuardPengawas accessibleByKepalaDinas>
    <DaftarSekolah {...props} />
  </PageGuardPengawas>
)

Page.Layout = KinerjaLayout

Page.layoutOpts = {
  hasHeader: true,
  centered: true,
  pageTitle: 'Penilaian Kinerja',
}

export default Page
